export const TicketStatus = {
    OPEN: "OPEN",
    PENDING: "PENDING",
    CLOSED: "CLOSED",
    REOPENED: "REOPENED"
}
export const TicketPriority = {
    LOW: "LOW",
    MEDIUM: "MEDIUM",
    HIGH: "HIGH"
}
export const UserStatus = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
}